/**
 * Public API Surface of CrashDumpApi functions
 */

export * from './post-retrieve-crash-logs';
